import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Container, Stack, Typography } from '@mui/material'
import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'

const RegisterConfirmError: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Container component='main' maxWidth='xs'>
      <Stack spacing={4} textAlign='center' sx={{ mt: '50px' }}>
        <Typography variant='h2'>{t('login:registerConfirmErrorHeadline')}</Typography>
        <Typography>{t('login:registerConfirmErrorText')}</Typography>
        <ButtonComponent
          fullWidth
          variant='contained'
          color='primary'
          text={t('login:registerConfirmErrorButton')}
          onClick={() => history.push('/login')}
        />
      </Stack>
    </Container>
  )
}

export default RegisterConfirmError
